const PageTypes = {
    INDEX_PAGE: 'IndexPage',
    PRODUCT_PAGE: 'ProductPage',
    TYRESHOPS_PAGE: 'TyreshopsPage',
    CATALOG_PAGE: 'CatalogPage',
    CART_PAGE: 'CartPage',
    GUIDES_PAGE: 'GuidesPage',
    CHECKOUT_PAGE: 'CheckoutPage',
    SERIES_PAGE: 'SeriesPage',
    CONTACT_PAGE: 'ContactPage',
    CAREER_PAGE: 'CareerPage',
    FITTING_PARTNER_PAGE: 'FittingPartnerPage',
    FITTING_STATION_PAGE: 'FittingstationPage',
    NEWSLETTER_SIGNUP_PAGE: 'NewsletterSignupPage',
    BLOG_PAGE: 'BlogPage',
    PAGE: 'Page'
};

export default PageTypes;